export const AuthenticationTexts = {
  ConsentsScreen: {
    title: 'Подтвердите согласие на получение выгодных предложений и информации',
    buttonText: 'Продолжить',
  },
  InitialScreen: {
    title: 'Войдите, чтобы продолжить',
    buttonText: 'Продолжить',
  },
  OtpScreen: {
    title: 'Войдите, чтобы продолжить',
    buttonText: 'Продолжить',
  },
};
